import React, {useContext, useEffect, useRef, useState} from 'react';
import {LayoutContext} from "../../../../../../layout/context/LayoutContext";
import {Toast} from "primereact/toast";
import {usePagination} from "../../../../../../layout/hooks/usePagination";
import {useFetch} from "../../../../../../layout/hooks/useFetch";
import {webInfo} from "../../../../../../utils/webInfo";
import callToast, {
    handleChangeData,
    mergeWithSelected,
    postData,
    validateFormFields
} from "../../../../../../utils/helper";
import {Button} from "primereact/button";
import PageHeading from "../../../../../../Components/PageHeading";
import {DataTable, DataTableRowToggleEvent} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import Label from "../../../../../../Components/Label";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";

interface InitialState {
    name: string,
    document: {
        id: number,
        employee_document_type: { id: number|null, name: string } | null,
        is_required: { id: number, name: string}
    }[]
}

const DesignationTypes = () => {
    const initialState: InitialState = {
        name: '',
        document: [{
            id: Date.now(),
            employee_document_type: null,
            is_required: {id: 1, name: 'Required'}
        }]
    };

    const {accessToken} = useContext(LayoutContext)
    const [refresh, setRefresh] = useState<boolean>(false);
    const [formData, setFormData] = useState<InitialState>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const toast = useRef<Toast | null>(null)
    const [expandedRows, setExpandedRows] = useState<any | undefined>(undefined);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const [modal, setModal] = useState<boolean>(false);
    const [updatedId, setUpdatedId] = useState<number | null>(null);
    const [filterDocumentTypeName, setFilterDocumentTypeName] = useState<string>('');
    const [documentTypeOptions, setDocumentTypeOptions] = useState<any[]>([]);


    const {page, limitData, handlePageChange} = usePagination();

    const mainTitle = "Designation Types"
    const tableDataEndpointUrl = `/employee-designations?page=${page} `
    const submitFormEndpointUrl = updatedId ? `/employee-designations/${updatedId}` : "/employee-designations";

    const requirementOptions = [
        {id: 1, name: 'Required'},
        {id: 0, name: 'Not Required'}
    ];

    // fetch data
    const { data: tableDataList, totalData, loading } = useFetch(tableDataEndpointUrl, [refresh])

    const { data: documentTypeRawData } = useFetch(
        `/employee-document-types?page=1&per_page=2${filterDocumentTypeName?.length > 0 ? `&name=${filterDocumentTypeName}` : ''}`,
        [refresh, filterDocumentTypeName]
    );

    console.log('documentTypeRawData: ', documentTypeRawData);
    console.log("documentTypeOptions: ", documentTypeOptions);
    console.log("formdata: ", formData);
    useEffect(() => {
        if (documentTypeRawData) {
            const modifiedData = documentTypeRawData?.map((item: any) => ({
                id: item?.id,
                name: item?.name
            }));

            const selectedTypes = formData.document
                .filter(doc => doc.employee_document_type !== null)
                .map(doc => ({
                    id: doc.employee_document_type!.id,
                    name: doc.employee_document_type!.name
                }));

            setDocumentTypeOptions(mergeWithSelected(modifiedData, selectedTypes));
        }
    }, [documentTypeRawData, formData.document]);


    const addField = () => {
        setFormData({
            ...formData,
            document: [
                ...formData?.document,
                {
                    id: Date.now(),
                    employee_document_type: null,
                    is_required: {id: 1, name: 'Required'}
                },
            ],
        });
    };

    const handleRemoveRow = (id: number) => {
        setFormData({
            ...formData,
            document: formData?.document?.filter(item => item?.id !== id)
        });
    }

    const isScaleFilled = (scale: any) => {
        return scale?.employee_document_type !== null && scale?.employee_document_type !== undefined;
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const validationRules = [{field: 'name', label: 'Name'}];
        if (!validateFormFields(formData, validationRules, toast)) return;

        const payload = {
            name: formData?.name?.replace(/\s+/g, ' ')?.trim(),
            document: formData?.document
                ?.filter(doc => doc?.employee_document_type !== null)
                ?.map(doc => ({
                    employee_document_type_id: doc?.employee_document_type?.id,
                    is_required: doc?.is_required?.id
                }))
        };

        try {
            setIsSubmitting(true);
            const response = await fetch(`${webInfo?.baseUrl}${submitFormEndpointUrl}`, postData("PUT" , accessToken, payload));

            if (response?.ok) {
                callToast(toast, true, `${mainTitle} ${updatedId ? 'updated' : 'created'} successfully`);
                setFormData(initialState)
                setModal(false)
                setUpdatedId(null)
                setRefresh(!refresh);
            } else {
                const resData = await response?.json();
                callToast(toast, false, resData?.error || "An error occurred");
            }
        } catch (err) {
            console.error('Failed to update', err);
        } finally {
            setIsSubmitting(false);
        }
    }

    const actionTemplate = (rowData: any) => {
        return (
            <div className={'flex align-items-center justify-content-end'}>
                <Button icon={'pi pi-pencil'} className={'border-rounded w-2rem h-2rem'} onClick={() => {
                    setModal(true)
                    setUpdatedId(rowData?.id)
                    setFormData({
                        name: rowData?.name || '',
                        document: rowData?.document_requirements?.map((item: any) => ({
                            id: item?.id || Date.now() + Math.random(),
                            employee_document_type: {
                                id: item?.employee_document_type_id,
                                name: item?.employee_document_type?.name || ''
                            },
                            is_required: item?.is_required === 1 ? {id: 1, name: 'Required'} : {id: 0, name: 'Not Required'}
                        })) || []
                    });
                }} outlined/>
            </div>
        )
    }

    const documentTemplateBody = (rowData: any) => {
        const count = rowData?.document_requirements?.length || 0;
        return <span className={'text-sm text-gray-600'}>{count > 0 ? `Required ${count} document(s)` : 'No document required'}</span>
    }

    const rowExpansionTemplate = (data: any) => {
        return (
            <DataTable value={data?.document_requirements} dataKey="id">
                <Column field="employee_document_type.name" header="Document Type" />
                <Column
                    header="Requirements"
                    body={(row) => (
                        <span className={`custom-badge ${row?.is_required === 1 ? 'approved' : 'cancelled'}`}>
                            {row?.is_required === 1 ? "Required" : "Not Required"}
                        </span>
                    )}
                />
            </DataTable>
        );
    };

    return (
        <div className={"card"}>
            <Toast ref={toast}/>
            <PageHeading title={mainTitle} isCreate={true} createFunction={() => setModal(true)} back={true} />

            <DataTable
                value={tableDataList}
                dataKey="id"
                paginator={tableDataList?.length > 0}
                lazy
                first={(page - 1) * limitData}
                rows={limitData}
                totalRecords={totalData}
                loading={loading}
                onPage={handlePageChange}
                expandedRows={expandedRows}
                onRowToggle={(e: DataTableRowToggleEvent) => setExpandedRows(e?.data)}
                rowExpansionTemplate={rowExpansionTemplate}
            >
                <Column expander={(rowData) => rowData?.document_requirements?.length > 0} style={{width: '3rem'}}/>
                <Column field="name" header="Name" style={{width: '50%'}} />
                <Column header="Document" body={documentTemplateBody} style={{width: '50%'}} />
                <Column header={"Action"} body={actionTemplate} bodyStyle={{textAlign: 'center'}} headerClassName={"flex justify-content-end"} />
            </DataTable>

            <Dialog visible={modal} style={{width: "55rem"}} header={updatedId ? `Edit ${mainTitle}` : `New ${mainTitle}`} onHide={() => { setUpdatedId(null); setModal(false); setFormData(initialState); }}>
                <form onSubmit={handleSubmit}>
                    <div className="grid">
                        <div className="col-6">
                            <Label label={"Name"} required={!updatedId}/>
                            <InputText
                                value={formData?.name}
                                onChange={(e) => handleChangeData('name', e.target.value, formData, setFormData)}
                                placeholder={"Enter name"}
                                className="w-full"
                            />
                        </div>
                    </div>

                    <div className="mt-4">
                        {formData?.document?.map((scale, idx) => {
                            const rowRequired = isScaleFilled(scale);
                            return (
                                <div key={scale?.id} className="border-2 border-gray-100 border-round-lg p-4 mb-4">
                                    <div className="flex justify-content-end mb-1">
                                        {formData?.document?.length > 1 && (
                                            <Button type="button" icon="pi pi-fw pi-times" outlined severity="danger" onClick={() => handleRemoveRow(scale?.id)} className="border-circle w-2rem h-2rem" />
                                        )}
                                    </div>
                                    <div className={"grid align-items-center gap-3"}>
                                        <div className="col-12 md:col-6">
                                            <Label label="Document Type" required={rowRequired} />
                                            <Dropdown
                                                value={scale?.employee_document_type}
                                                options={documentTypeOptions ? documentTypeOptions : []}
                                                optionLabel="name"
                                                placeholder="Select document type"
                                                className="w-full"
                                                filter
                                                onFilter={(e) => {
                                                    if (timeoutRef.current) clearTimeout(timeoutRef.current);
                                                    timeoutRef.current = setTimeout(() => setFilterDocumentTypeName(e?.filter || ''), 500);

                                                    if (documentTypeRawData) {
                                                        const modifiedData = documentTypeRawData?.map((item: any) => ({
                                                            id: item?.id,
                                                            name: item?.name
                                                        }));
                                                        setDocumentTypeOptions(modifiedData);
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    const updated = [...formData?.document];
                                                    updated[idx].employee_document_type = e?.value;
                                                    setFormData({ ...formData, document: updated });
                                                }}
                                                showClear
                                                showFilterClear
                                            />
                                        </div>
                                        <div className="col-12 md:col-4">
                                            <Label label="Requirement" required={rowRequired} />
                                            <Dropdown
                                                value={scale?.is_required}
                                                options={requirementOptions}
                                                optionLabel="name"
                                                className="w-full"
                                                onChange={(e) => {
                                                    const updated = [...formData?.document];
                                                    updated[idx].is_required = e?.value;
                                                    setFormData({ ...formData, document: updated });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="flex gap-2 mt-4">
                        <Button type="submit" label={updatedId ? 'Update' : "Create"} className="p-button-primary" size={'small'} loading={isSubmitting} />
                        <Button type="button" icon="pi pi-fw pi-plus" label="Add Row" onClick={addField} className="p-button-outlined" size="small" />
                    </div>
                </form>
            </Dialog>
        </div>
    );
};

export default DesignationTypes;